import React from 'react';
import PropTypes from 'prop-types';

import { pluralize } from 'helpers/formatters/string_formats';

export default function OpenTasks({ deal }) {
  const openTaskCount = (deal.tasks || []).filter(task => !task.completed).length;
  const taskLabel = pluralize(openTaskCount, 'task') + ' open';
  return <a href={deal.path + '/planner'}>{taskLabel}</a>;
}

OpenTasks.propTypes = {
  deal: PropTypes.shape({
    path: PropTypes.string.isRequired,
    tasks: PropTypes.arrayOf(PropTypes.shape({
      completed: PropTypes.bool,
    })),
  }).isRequired,
};
